import styled from 'styled-components'
import { BoxDefault } from '../../../../../../../components/BoxContainer/styles'

export const Container = styled.div`
  ${BoxDefault} {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
  }
`

export const BoxBrand = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--background);
  border: 1px solid var(--border-color-table);
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px;
  min-width: 184px;
  position: relative;

  > button {
    background: none;
    border: none;
    position: absolute;
    right: 17px;
    top: 12px;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h3 {
    margin-top: 14px;
    margin-bottom: 0;
    text-align: center;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
  }
`

export const BoxChooses = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CanvasContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  > canvas {
    object-fit: contain;
    height: 100%;
  }
`
